import type { ExtractPartial } from '../client/extract-failure'

/**
 * #1459 Codex review — what a phone says when an extract stopped part-way: what it already wrote stays (mobile has no
 * undo, so it says only that), and a retry that keeps both would make a second copy. `null` when nothing was written.
 */
export function extractPartialMobileText(err: unknown, t: (key: string, opts?: Record<string, unknown>) => string): string | null {
  const partial = (err as { partial?: ExtractPartial } | null)?.partial
  if (!partial) return null
  // created AND replaced, each item once (#1459 Codex review: `a//x.txt` then `a/x.txt` creates x.txt and versions it)
  const count = new Set([...partial.fileIds, ...partial.versioned.map((v) => v.fileId)]).size
  if (count === 0 && !partial.destinationFolderId) return null
  return t('driveView.toast.extractPartialMobile', { count: Math.max(count, 1) })
}
